// NavDistricts.js
import React from "react";
import { Link } from "react-router-dom";

const NavDistricts = () => {
  return (
    <fragment>
      <p>
        <div class="bitdFont morkBorgText" style={{ textAlign: "center" }}>
          💀{" "}
          <a style={{ color: "yellow" }} href="./blades-in-the-dark-overview">
            What Is Blades In The Dark?
          </a>{" "}
          💀
          <a
            style={{ color: "yellow" }}
            href="./blades-in-the-dark-classes-core"
          >
            Classes
          </a>{" "}
          💀
          <a style={{ color: "yellow" }} href="./blades-in-the-dark-crews-core">
            Crews
          </a>{" "}
          💀
          <a
            style={{ color: "yellow" }}
            href="./blades-in-the-dark-campaign-introduction"
          >
            Campaign
          </a>{" "}
          💀
        </div>
      </p>
    </fragment>
  );
};

export default NavDistricts;
